<template>
  <v-layout row class="mx-0 ">
    <v-flex xs12>

      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">Full Name</th>
            <th class="text-left">DoB</th>
            <th class="text-left">Country</th>
            <th class="text-left">Action</th>
          </tr>
          </thead>
          <tbody v-if="similar_travellers.length">
          <tr v-for="traveller in similar_travellers" :key="traveller.id">
            <td>{{ traveller.full_name }}</td>
            <td>{{ traveller.dob }}</td>
            <td>{{ traveller.country_name }}</td>
            <td>
              <v-btn @click="viewTraveller(traveller.id)" color="primary" title="View Detail" fab x-small>
                <v-icon>
                  remove_red_eye
                </v-icon>
              </v-btn>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr style="text-align: center">
            <td colspan="4">{{ 'No Similar Travellers Found' }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "SimilarTravellers",
  props: ['similar_travellers'],
  data() {
    return {}
  },
  methods:{
    viewTraveller(id) {
      window.open('/admin/system/travellers-history/view/' + id, '_blank')
    },
  }
}
</script>
